import { FC, lazy, Suspense } from "react";

import type { Change } from "diff";
import type { Language } from "src/components/editor";
import type { ImageLine } from "src/components/editor/image-line-widgets";

interface Props {
  diffs: Change[];
  /** @default json */
  language?: Language;
  /** @default "border" */
  variant?: "border" | "plain";
  /**
   * Lines to render as images instead of text (a markdown image line, say). The
   * line keeps its added or removed coloring. Resolved once when the editor
   * mounts, so change the component's key when the answers change.
   */
  imageLines?: (lineText: string) => ImageLine | null;
}

const DiffInner = lazy(() =>
  import("./diff-inner").then((m) => ({ default: m.Diff })),
);

export const Diff: FC<Readonly<Props>> = (props) => {
  return (
    <Suspense fallback={null}>
      <DiffInner {...props} />
    </Suspense>
  );
};
